import script from "./GridComandaDetalii.vue?vue&type=script&lang=ts&setup=true"
export * from "./GridComandaDetalii.vue?vue&type=script&lang=ts&setup=true"

import "./GridComandaDetalii.vue?vue&type=style&index=0&id=0342a0fc&scoped=true&lang=css"
import "./GridComandaDetalii.vue?vue&type=style&index=1&id=0342a0fc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0342a0fc"]])

export default __exports__